import axios from "axios";
export const sistemaPluviometricoApi = (token) => axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/v1/api-pluviometrico`,
    headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: token ? `Bearer ${token}` : undefined,
        "app-key": process.env.REACT_APP_APP_KEY || "",
    },
});
export const nominatimApi = () => {
    return axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/v1/api-nominatim`,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "app-key": process.env.REACT_APP_APP_KEY || "",
        },
    });
};
